// src/messagerie/routePaths.js
// Routes dédiées à la messagerie (patient + docteur)

export const MESSAGING_ROUTES = {
  PATIENT: "/messaging",
  DOCTOR: "/messages",
};

export default MESSAGING_ROUTES;
